export const getPrintTemplate = ({ data }) => {
  const renderLines = (lines = []) =>
    (lines || [])
      .map((line) => `<div>- ${line || ""}</div>`)
      .join("");

  return `
  <html>
    <head>
      <title>Hợp Đồng Giao Khoán</title>
      <style>
        @media print { @page { margin: 10mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 16px; color: #000; padding: 24px; }
        .row { margin-top: 8px; }
        .header { display: flex; justify-content: space-between; }
        .center { text-align: center; }
        .sign { display:flex; justify-content: space-between; margin-top: 28px; text-align: center; }
        .sign-box { width: 42%; }
        .sign-space { height: 56px; }
        .sign-name { font-weight: bold; margin-top: 4px; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div>
          <div><b>Đơn vị:</b> ${data.unit || ""}</div>
          <div><b>Bộ phận:</b> ${data.department || ""}</div>
        </div>
        <div class="center">
          <div><b>Mẫu số: 05 - LĐTL</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC<br/>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <h2 class="center" style="margin:16px 0 6px">HỢP ĐỒNG GIAO KHOÁN</h2>
      <div class="center">Ngày ${data.contractDate || ".../.../..."}</div>
      <div class="row" style="text-align:right">Số: ${data.contractNumber || ""}</div>

      <div class="row">Họ và tên: ${data.assignorName || ""}. Chức vụ: ${data.assignorTitle || ""}</div>
      <div class="row">Đại diện: ${data.assignorRepresentativeOf || ""} bên giao khoán</div>
      <div class="row">Họ và tên: ${data.assigneeName || ""}. Chức vụ: ${data.assigneeTitle || ""}</div>
      <div class="row">Đại diện: ${data.assigneeRepresentativeOf || ""} bên nhận khoán</div>

      <div class="row"><b>CÙNG KÝ KẾT HỢP ĐỒNG GIAO KHOÁN NHƯ SAU:</b></div>
      <div class="row"><b>I- Điều khoản chung:</b></div>
      <div class="row">- Phương thức giao khoán: ${data.assignmentMethod || ""}</div>
      <div class="row">- Điều kiện thực hiện hợp đồng: ${data.executionConditions || ""}</div>
      <div class="row">- Thời gian thực hiện hợp đồng: ${data.executionDuration || ""}</div>
      <div class="row">- Các điều kiện khác: ${data.otherConditions || ""}</div>

      <div class="row"><b>II- Điều khoản cụ thể:</b></div>
      <div class="row"><b>1. Nội dung công việc khoán:</b></div>
      ${renderLines(data.workContents)}

      <div class="row"><b>2. Trách nhiệm, quyền lợi và nghĩa vụ của người nhận khoán:</b></div>
      ${renderLines(data.assigneeResponsibilities)}

      <div class="row"><b>3. Trách nhiệm, quyền lợi và nghĩa vụ của bên giao khoán:</b></div>
      ${renderLines(data.assignorResponsibilities)}

      <div class="sign">
        <div class="sign-box">
          <b>Đại diện bên nhận khoán</b><br/>
          <i>(Ký, họ tên)</i>
          <div class="sign-space"></div>
          <div class="sign-name">${data.assigneeSignName || data.assigneeName || ""}</div>
        </div>
        <div class="sign-box">
          <b>Đại diện bên giao khoán</b><br/>
          <i>(Ký, họ tên)</i>
          <div class="sign-space"></div>
          <div class="sign-name">${data.assignorSignName || data.assignorName || ""}</div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>`;
};
